import { useContext } from 'react';

import { InputContext } from 'src/contexts/input.context';
import { InlineInput } from 'src/components/Inputs';
import { CSIAutoComplete, CSIAutoCompleteInputProps } from '../CSIAutoComplete';

export function InlineCSIAutoComplete() {
  const { isDisabled, isReadonly, isAutoFocus, classNames } = useContext(InputContext);

  function renderInput({
    onFocus,
    onClick,
    onBlur,
    onDiscard,
    onSubmit,
    isLoading,
    onChange,
    value,
  }: CSIAutoCompleteInputProps) {
    return (
      <InlineInput
        className={classNames?.input}
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        onClick={onClick}
        onBlur={onBlur}
        isDisabled={isDisabled}
        isReadonly={isReadonly}
        autoFocus={isAutoFocus}
        onDiscard={onDiscard}
        onSubmit={onSubmit}
        isLoading={isLoading}
      />
    );
  }

  return <CSIAutoComplete renderInput={renderInput} />;
}
